<template>
    <modal v-model="opened" :transition='0' :append-to-body="true" :backdrop="false"
           class="add-profile-info-popup">
        <template #header>
            <div>
                <a id="close_popup" @click="closePopup"></a>
                <h3 class="modal-title">{{header}}</h3>
            </div>
        </template>
        <div class="row margin-15-bottom">
            <div class="col-sm-12">
                <p> You haven’t added anything to your Profile yet!</p>
                <p>Your Profile is your page where you can add some information about you for others to see on Multi
                    Me.</p>
            </div>
        </div>
        <template #footer>
            <div>
                <div class="row">
                    <div class="col-xs-12 ">
                        <button class="btn btn-mm" @click="closePopup"><i class="fa fa-times"></i> Remind me later</button>
                        <a :href="aboutMeHref" @click.prevent.stop="goToProfile">
                            <button class="btn btn-mm btn-green save-button">
                                <i class="fa fa-check"></i> Go to Profile
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
    import {navigateTo} from '~/spa/navigate';
    import {DjangoUrls} from 'DjangoUrls';
    import {CurrentUserClass} from "../shared/CurrentUser";

    export default {
        name: "AddProfileInfoRequestPopup",
        data() {
            return {
                firstName: '',
                lastName: '',
                opened: false,
                username: '',
            };
        },
        computed: {
            aboutMeHref() {
                return `${DjangoUrls['user_detail_me']()}profile`;
            },
            header() {
                const cu = new CurrentUserClass();
                const username = cu.first_name || cu.username;
                return `Hello ${username}`;
            },
            allowSave() {
                return this.firstName && this.lastName;
            }
        },
        methods: {
            closePopup() {
                this.opened = false;
                this.reject();
            },
            show() {
                this.opened = true;
                return new Promise((res, rej) => {
                    this.resolve = res;
                    this.reject = rej;
                });
            },
            goToProfile() {
                this.opened = false;
                navigateTo(this.aboutMeHref);
                this.resolve();
            }
        }
    };
</script>

<style scoped lang="scss">
    @use "../styles/const" as *;

    .add-profile-info-popup {
        font-size: $bigger-font-size;
    }

</style>